"use strict";
/*
 * Copyright 2024, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBirdSpeedKph = exports.getBirdDistanceMeters = void 0;
const geojson_validation_1 = require("geojson-validation");
const turf_1 = require("@turf/turf");
/**
 * Get the bird distance in meters, ceil to meters (integer)
 * @param originGeography - The origin geography
 * @param destinationGeography - The destination geography
 * @returns The distance in meters, or undefined if no origin or destination or if the origin or destination is not a valid point
 */
const getBirdDistanceMeters = (originGeography, destinationGeography) => {
    if (originGeography &&
        destinationGeography &&
        originGeography.geometry &&
        destinationGeography.geometry &&
        (0, geojson_validation_1.isFeature)(originGeography) &&
        (0, geojson_validation_1.isPoint)(originGeography.geometry) &&
        (0, geojson_validation_1.isFeature)(destinationGeography) &&
        (0, geojson_validation_1.isPoint)(destinationGeography.geometry)) {
        return Math.ceil((0, turf_1.distance)(originGeography, destinationGeography, { units: 'meters' }));
    }
    return undefined;
};
exports.getBirdDistanceMeters = getBirdDistanceMeters;
/**
 * Get the bird speed in km/h, not rounded
 * @param originGeography - The origin geography
 * @param destinationGeography - The destination geography
 * @param durationSeconds - The duration in seconds
 * @returns The speed in km/h, or undefined if no duration, origin or destination or if the origin or destination is not a valid point
 */
const getBirdSpeedKph = (originGeography, destinationGeography, durationSeconds) => {
    const distanceMeters = (0, exports.getBirdDistanceMeters)(originGeography, destinationGeography);
    if (durationSeconds !== undefined && durationSeconds > 0 && distanceMeters !== undefined && distanceMeters >= 0) {
        return (distanceMeters / durationSeconds) * 3.6;
    }
    return undefined;
};
exports.getBirdSpeedKph = getBirdSpeedKph;
//# sourceMappingURL=PhysicsUtils.js.map